import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IAddDirectorRequest } from '../models/add-director.model';

export const loadAddDirectors = createAction(
  '[AddDirector] Load AddDirectors',
  props<{ request: IAddDirectorRequest; businessId: string }>()
);

export const loadAddDirectorsSuccess = createAction('[AddDirector] Load AddDirectors Success', props<{ response: string }>());

export const loadAddDirectorsFailure = createAction(
  '[AddDirector] Load AddDirectors Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
